import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const TrustSignals = () => {
  const clientLogos = [
    {
      name: 'TechStart Solutions',
      logo: 'https://images.unsplash.com/photo-1560472354-b33ff0c44a43?w=120&h=60&fit=crop',
      industry: 'SaaS'
    },
    // {
    //   name: 'Urban Fitness Co.',
    //   logo: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=120&h=60&fit=crop',
    //   industry: 'Fitness'
    // },
    {
      name: 'EcoShop Marketplace',
      logo: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=120&h=60&fit=crop',
      industry: 'E-commerce'
    },
    // {
    //   name: 'Legal Partners LLC',
    //   logo: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=120&h=60&fit=crop',
    //   industry: 'Legal'
    // },
    // {
    //   name: 'Creative Studios Inc.',
    //   logo: 'https://images.unsplash.com/photo-1542744173-8e7e53415bb0?w=120&h=60&fit=crop',
    //   industry: 'Creative'
    // },
    {
      name: 'Tarot Chat',
      logo: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=120&h=60&fit=crop',
      industry: 'Finance'
    }
  ];

  const certifications = [
    {
      name: 'Google Partner',
      icon: 'Award',
      description: 'Certified Google Ads & Analytics Partner',
      color: 'text-trust'
    },
    {
      name: 'Meta Business Partner',
      icon: 'Shield',
      description: 'Official Facebook & Instagram Marketing Partner',
      color: 'text-accent'
    },
    {
      name: 'HubSpot Certified',
      icon: 'Star',
      description: 'Inbound Marketing & Sales Certification',
      color: 'text-warning'
    },
    {
      name: 'AWS Certified',
      icon: 'Cloud',
      description: 'Amazon Web Services Solutions Architect',
      color: 'text-conversion'
    }
  ];

  const awards = [
    {
      year: '2024',
      title: 'Best Digital Agency',
      organization: 'Tech Innovation Awards',
      icon: 'Trophy'
    },
    {
      year: '2023',
      title: 'Excellence in Web Development',
      organization: 'Digital Marketing Institute',
      icon: 'Medal'
    },
    {
      year: '2023',
      title: 'Top Social Media Campaign',
      organization: 'Marketing Excellence Awards',
      icon: 'Award'
    }
  ];

  return (
    <section className="py-20 bg-surface">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Client Logos */}
        <div className="text-center mb-16">
          <h2 className="text-2xl font-bold text-foreground mb-8">
            Trusted by Forward-Thinking Businesses
          </h2>
          
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8 items-center">
            {clientLogos?.map((client, index) => (
              <div
                key={index}
                className="group relative bg-card rounded-lg p-4 brand-shadow hover:brand-shadow-lg brand-transition brand-hover-lift"
              >
                <div className="aspect-[2/1] overflow-hidden rounded">
                  <Image
                    src={client?.logo}
                    alt={`${client?.name} logo`}
                    className="w-full h-full object-cover opacity-70 group-hover:opacity-100 brand-transition"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 brand-transition rounded-lg"></div>
                <div className="absolute bottom-2 left-2 right-2 opacity-0 group-hover:opacity-100 brand-transition">
                  <div className="text-xs font-medium text-white">{client?.name}</div>
                  <div className="text-xs text-white/80">{client?.industry}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Certifications & Awards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Certifications */}
          {/* <div>
            <h3 className="text-xl font-bold text-foreground mb-8 text-center lg:text-left">
              Industry Certifications
            </h3>
            <div className="space-y-4">
              {certifications?.map((cert, index) => (
                <div
                  key={index}
                  className="flex items-center space-x-4 bg-card rounded-lg p-4 brand-shadow brand-hover-lift brand-transition"
                >
                  <div className="flex-shrink-0 w-12 h-12 bg-surface rounded-lg flex items-center justify-center">
                    <Icon name={cert?.icon} size={24} className={cert?.color} />
                  </div>
                  <div>
                    <h4 className="font-semibold text-foreground">{cert?.name}</h4>
                    <p className="text-sm text-muted-foreground">{cert?.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div> */}

          {/* Awards */}
          {/* <div>
            <h3 className="text-xl font-bold text-foreground mb-8 text-center lg:text-left">
              Recent Awards & Recognition
            </h3>
            <div className="space-y-4">
              {awards?.map((award, index) => (
                <div
                  key={index}
                  className="flex items-center space-x-4 bg-card rounded-lg p-4 brand-shadow brand-hover-lift brand-transition"
                >
                  <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-accent to-conversion rounded-lg flex items-center justify-center">
                    <Icon name={award?.icon} size={24} className="text-white" />
                  </div>
                  <div>
                    <div className="flex items-center space-x-2">
                      <h4 className="font-semibold text-foreground">{award?.title}</h4>
                      <span className="text-xs bg-accent/10 text-accent px-2 py-1 rounded-full">
                        {award?.year}
                      </span>
                    </div>
                    <p className="text-sm text-muted-foreground">{award?.organization}</p>
                  </div>
                </div>
              ))}
            </div>
          </div> */}
        </div>

        {/* Security & Trust Badges */}
        {/* <div className="mt-16 pt-12 border-t border-border">
          <div className="flex flex-wrap items-center justify-center gap-8">
            <div className="flex items-center space-x-2 text-muted-foreground">
              <Icon name="Shield" size={20} className="text-success" />
              <span className="text-sm">SSL Secured</span>
            </div>
            <div className="flex items-center space-x-2 text-muted-foreground">
              <Icon name="Lock" size={20} className="text-success" />
              <span className="text-sm">GDPR Compliant</span>
            </div>
            <div className="flex items-center space-x-2 text-muted-foreground">
              <Icon name="CheckCircle" size={20} className="text-success" />
              <span className="text-sm">ISO 27001 Certified</span>
            </div>
            <div className="flex items-center space-x-2 text-muted-foreground">
              <Icon name="Globe" size={20} className="text-success" />
              <span className="text-sm">Global Reach</span>
            </div>
          </div>
        </div> */}

        {/* Stats Bar */}
        <div className="mt-12 bg-gradient-to-r from-primary to-accent rounded-2xl p-8 text-white">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-3xl font-bold">2+</div>
              <div className="text-sm opacity-90">Years Experience</div>
            </div>
            <div>
              <div className="text-3xl font-bold">10+</div>
              <div className="text-sm opacity-90">Projects Delivered</div>
            </div>
            <div>
              <div className="text-3xl font-bold">10+</div>
              <div className="text-sm opacity-90">Happy Clients</div>
            </div>
            <div>
              <div className="text-3xl font-bold">340%</div>
              <div className="text-sm opacity-90">Average ROI</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustSignals;